import { Box, ListItem, SvgIcon, Typography } from '@mui/material';
import ChevronRightIcon from 'assets/icons/chevron-right.svg';
import { string } from 'prop-types';
import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import linkPreviews from 'store/app/entities/linkPreviews/action';
import getLinkPreview from 'store/selectors/getLinkPreview';

const LinkItem = ({ link }) => {
  const preview = useSelector(state => getLinkPreview(state, link));
  const dispatch = useDispatch();
  useEffect(() => {
    if (!preview) {
      dispatch(linkPreviews.fetchLinkPreview(link));
    }
  }, [preview, dispatch, link]);
  return (
    <ListItem
      sx={{
        height: '70px',
        alignItems: 'center',
        borderBottom: 'solid 1px #dde2eb',
      }}
    >
      <Box
        component="a"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          textDecoration: 'none',
          color: 'inherit',
        }}
      >
        <Typography component="div">
          <div>{preview?.title}</div>
          <Box component="div" sx={{ color: 'primary.main' }}>
            {link}
          </Box>
        </Typography>
      </Box>
      <SvgIcon sx={{ fontSize: 14 }}>
        <ChevronRightIcon />
      </SvgIcon>
    </ListItem>
  );
};

LinkItem.propTypes = {
  link: string.isRequired,
};

export default memo(LinkItem);
